import {React,useState} from "react";
import Sidebar from "../../Components/Sidebar/sidebar";
import { Alert, Layout } from "antd";
import { Routes, Route } from "react-router-dom";
import ConfigGlobalSettings from "./GlobalSettings/globalSettings";
import AddNewCustomer from "./CustomerDetails/addNewCustomer";
import HeaderNav from "../../Components/Header/Header";
import EditCustomer from "./CustomerDetails/editCustomer";
import CustomerRecordsData from "./CustomerDetails/customerRecords";
import ProductsRecordsData from "./ProductsRecords/productsRecords";
import AddNewProducts from "./ProductsRecords/addNewProducts";
import EditProductsRecords from "./ProductsRecords/editProductsRecords";
import EditMachine from "./MachineRecords/editMachine";
import AddNewMachine from "./MachineRecords/addNewMachine";
import MachineRecordsData from "./MachineRecords/machineRecords";
import ExportCustomer from "./CustomerDetails/exportCustomer";
import ExportProduct from "./ProductsRecords/exportProduct";
import ExportMachine from "./MachineRecords/exportMachine";
import ExportMachinePdf from "../../Pages/Exports/exportMachinePdf";
import ExportProductPdf from "../../Pages/Exports/exportProductPdf";
import ExportCustomerPdf from "../../Pages/Exports/exportCustomerPdf"
import LogTable from "../../Components/Log/logTable";
import ImportProduct from "./ProductsRecords/importProduct";
import ImportCustomer from "./CustomerDetails/importCustomer";
import PreparingUploadProduct from "./ProductsRecords/preparingUploadProduct";
import ProductValidation from "./ProductsRecords/productValidation";
import PreparingUploadCustomer from "./CustomerDetails/preparingUploadCustomers";
import CustomerValidation from "./CustomerDetails/customerValidation";
import ExportRecordsAnimation from "../Exports/exportRecordsAnimationScreen";
import WorkFlowSettings from "../Configurations/WorkflowSettings/workFlowSettings";
import CutterRecords from "../Configurations/MachineRecords/cutterRecords";
import RewinderRecords from "../Configurations/MachineRecords/rewinderRecords";
import AddEditViewRewinder from "../Configurations/MachineRecords/AddEditViewRewinder";
import AddEditViewCutter from "../Configurations/MachineRecords/AddEditViewCutter";
import ExportCutter from "../Configurations/MachineRecords/exportCutter";
import ExportCutterPdf from "../Exports/exportCutterPDF";
import ExportRewinder from "../Configurations/MachineRecords/exportRewinder";
import ExportRewinderPdf from "../Exports/exportRewinderPdf";
import MeasurementSystem from "./AdvancedSettings/measurementSystem";
import PackagingConfig from "./PackagingModule/packagingConfig";
import JobCardSerailNoConfig from "./AdvancedSettings/JobCardSerialNoConfig";
import OrderCreationConfig from "./AdvancedSettings/OrderCreationConfig";
import StockMatching from "./StockMatchingConfiguration/StockMatching";
import AlgorithmConfigDetails from "./AlgoConfig/algorithmconfigDetails";
const { Content } = Layout;

const Configurations = (props) => {
  const userDetails = JSON.parse(localStorage.getItem("user-details"));

const listItems = [];
if(userDetails.roles.global_settings.edit || userDetails.roles.global_settings.view )
{
listItems.push({
  icon: "agency",
  label: "Global Settings",
  link: "global-settings",
});
}
if(userDetails.roles.customer_records.edit || userDetails.roles.customer_records.view )
{
listItems.push({
  icon: "group-user",
  label: "Customer Records",
  link: "customer-records",
});
}
if(userDetails.roles.machine_records.edit || userDetails.roles.machine_records.view )
{
listItems.push({
  icon: "tissue-role",
  label: "Machine Records",
  link: "machine-records",
  subLinkList: [{
    icon: "group-user",
    label: "Paper Machine Records",
    link: "/configuration/machine-records",
  },
  {
    icon: "box-pack",
    label: "Rewinder Records",
    link: "/configuration/rewinder-records",
  },
  {
    icon: "box-pack",
    label: "Cutter Records",
    link: "/configuration/cutter-records",
  },
]
});
}
if(userDetails.roles.product_records.edit || userDetails.roles.product_records.view )
{
listItems.push({
  icon: "box-pack",
  label: "Product Records",
  link: "products-records",
});
}
if(userDetails.roles.workflow_settings.view)
{
listItems.push({
  icon: "workflow",
  label: "Workflow Settings",
  link: "workflow-settings",
});
}
if(userDetails.roles.advanced_settings.view || userDetails.roles.advanced_settings.edit)
{
listItems.push({
  icon: "setting",
  label: "Advanced Settings",
  link: "advanced-settings",
  subLinkList: [{
    icon: "group-user",
    label: "Measurement System",
    link: "/configuration/measurement-system",
  },
 {
    icon: "group-user",
    label: "Serial Number Config.",
    link: "/configuration/jobcard-config",
  },
   {
    icon: "group-user",
    label: "Order Creation Config.",
    link: "/configuration/order-creation-config",
  },
]
});
}

if(userDetails.roles?.packaging_config?.edit || userDetails.roles?.packaging_config?.view )
{
listItems.push({
  icon: "box-pack",
  label: "Packaging Config.",
  link: "packaging-config",
});
}
// if(userDetails.roles.inventory.stocks.edit ||
//   userDetails.roles.inventory.stocks.view){
//     listItems.push({
//       icon: "stock-matching-configuration",
//       label: "Stock Matching Config.",
//       link: "stock-matching-configuration",
//     });
//   }

// listItems.push({
//   icon: "box-pack",
//   label: "Algorithm Config.",
//   link: "algo-config",
// });

  return (
    <Layout>
      <HeaderNav />
      <Layout>
        <Sidebar headerName="Configurations" listItems={listItems} />
        <Layout>
          <Content>
            <Routes> 
              <Route path="global-settings" element={<ConfigGlobalSettings />} />
              {/* <Route path="edit-customer" element={<EditCustomer />} /> */}
              <Route path="customer-records" element={<CustomerRecordsData />} />
              <Route path="/customer-records/add-new-customer" element={<AddNewCustomer />} />
              <Route path="/customer-records/edit-customer" element={<AddNewCustomer />} />
              <Route path="/customer-records/view-customer" element={<AddNewCustomer />} />
              <Route path="/customer-records/export-customer" element={<ExportCustomer />} />
              <Route path="/customer-records/export-customer/pdf" element={<ExportCustomerPdf />} />
              <Route path="/customer-records/upload-customers" element={<ImportCustomer />} />
              <Route path="/customer-records/preparing-upload-customers" element={<PreparingUploadCustomer />} />
              <Route path="/customer-records/validate-customers" element={<CustomerValidation />} />
              <Route path="customer-records/preparing-export-customers" element={<ExportRecordsAnimation />}/>
              <Route path="products-records" element={<ProductsRecordsData />} />
              <Route path="/products-records/add-new-products" element={<AddNewProducts />} />
              <Route path="edit-products-records" element={<EditProductsRecords />} />
              <Route path="/products-records/export-product" element={<ExportProduct />} />
              <Route path="/products-records/export-product/pdf" element={<ExportProductPdf />} />
              <Route path="/products-records/upload-products" element={<ImportProduct />} />
              <Route path="/products-records/preparing-upload-products" element={<PreparingUploadProduct />} />
              <Route path="/products-records/validate-products" element={<ProductValidation />} />
              <Route path="/products-records/preparing-export-products" element={<ExportRecordsAnimation />}/>
              <Route path="edit-machine" element={<EditMachine />} />
              <Route path="add-new-machine" element={<AddNewMachine />} />
              <Route path="machine-records" element={<MachineRecordsData />} />
              <Route path="/machine-records/export-machine" element={<ExportMachine />} />
              <Route path="/machine-records/export-machine/pdf" element={<ExportMachinePdf />} />
              <Route path="/machine-records/preparing-export-machine" element={<ExportRecordsAnimation />}/>
              <Route path="cutter-records" element={<CutterRecords />} />
              <Route path="rewinder-records" element={<RewinderRecords />} />
              <Route path="history" element={<LogTable />} />
              <Route path="workflow-settings" element={<WorkFlowSettings />} />
              <Route path="add-new-rewinder" element={<AddEditViewRewinder />} />
              <Route path="edit-rewinder" element={<AddEditViewRewinder />} />
              <Route path="view-rewinder" element={<AddEditViewRewinder />} />
              <Route path="add-new-cutter" element={<AddEditViewCutter />} />
              <Route path="edit-cutter" element={<AddEditViewCutter />} />
              <Route path="view-cutter" element={<AddEditViewCutter />} />
              <Route path="/cutter-records/export-cutter" element={<ExportCutter />} />
              <Route path="/cutter-records/preparing-export-cutter" element={<ExportRecordsAnimation />}/>
              <Route path="/cutter-records/export-cutter/pdf" element={<ExportCutterPdf />} />
              <Route path="/rewinder-records/export-rewinder" element={<ExportRewinder />} />
              <Route path="/rewinder-records/preparing-export-rewinder" element={<ExportRecordsAnimation />}/>
              <Route path="/rewinder-records/export-rewinder/pdf" element={<ExportRewinderPdf />} />
              {/* <Route path="approve-records/preparing-export-orders" element={<ExportRecordsAnimation />}/> */}
              <Route path="measurement-system" element={<MeasurementSystem />} />
              <Route path="packaging-config" element={<PackagingConfig />} />
              <Route path="jobcard-config" element={<JobCardSerailNoConfig />} />
              <Route path="order-creation-config" element={<OrderCreationConfig />} />

              <Route path="stock-matching-configuration" element={<StockMatching />} />
             {/* <Route path="algo-config" element={<AlgorithmConfigDetails />} /> */}
            </Routes>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default Configurations;
